const FETCH_LAB_STATUSES= "FETCH_LAB_STATUSES";
const FETCH_LAB_STATUSES_SUCCESS = "FETCH_LAB_STATUSES_SUCCESS";
const FETCH_LAB_STATUSES_ERROR = "FETCH_LAB_STATUSES_ERROR";
const UPDATE_LAB_STATUSES = "UPDATE_LAB_STATUSES";
const UPDATE_LAB_STATUSES_SUCCESS = "UPDATE_LAB_STATUSES_SUCCESS";
const UPDATE_LAB_STATUSES_ERROR = "UPDATE_LAB_STATUSES_ERROR";
const DELETE_LAB_STATUSES = "DELETE_LAB_STATUSES";
const DELETE_LAB_STATUSES_SUCCESS = "DELETE_LAB_STATUSES_SUCCESS";
const DELETE_LAB_STATUSES_ERROR = "DELETE_LAB_STATUSES_ERROR";
const CREATE_LAB_STATUSES = "CREATE_LAB_STATUSES";
const CREATE_LAB_STATUSES_SUCCESS = "CREATE_LAB_STATUSES_SUCCESS";
const CREATE_LAB_STATUSES_ERROR = "CREATE_LAB_STATUSES_ERROR";
const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
const UPDATE_ORDER = "UPDATE_ORDER";
const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
const UPDATE_ORDER_ERROR = "UPDATE_ORDER_ERROR";

export {
  FETCH_LAB_STATUSES,
  FETCH_LAB_STATUSES_SUCCESS,
  FETCH_LAB_STATUSES_ERROR,
  UPDATE_LAB_STATUSES,
  UPDATE_LAB_STATUSES_SUCCESS,
  UPDATE_LAB_STATUSES_ERROR,
  DELETE_LAB_STATUSES,
  DELETE_LAB_STATUSES_SUCCESS,
  DELETE_LAB_STATUSES_ERROR,
  CREATE_LAB_STATUSES,
  CREATE_LAB_STATUSES_SUCCESS,
  CREATE_LAB_STATUSES_ERROR,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_ERROR,
  IS_ADDING_UPDATE,
};
